import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'
import * as apiMenu from "../../../../api/apiMenu"
import * as Auth from "../../../Login/Auth"
import { MHeader } from "./MenuTable"
import { ContentBox } from '../../Content/ContentBox';
import { ReqMenu } from '../../../../item/ItemMenu';
import { URL_MENU_ADDHEADER, URL_MENU_ADDTITLE, URL_MENU_ADDITEM } from '../../../../config';


//當我們宣告一個組件時，名稱第一字母必須大寫，這很重要ㄛ
export function AdminMenuAdd(props) {

    const [menuItems, setMenuItems] = useState([]);
    const [level, setLevel] = useState("0");
    const [menuName, setMenuName] = useState("");
    const [sequence, setSequence] = useState(0);
    const [icon, setIcon] = useState("");
    const [upperId, setUpperId] = useState("");
    const [link, setLink] = useState("");


    function getMenu() {
        apiMenu.getRealMenu({
            success: (obj, menuItems) => {
                console.log(obj)
                var menuList = [];
                obj.menus.forEach(result => {
                    menuList.push(result);
                });
                setMenuItems(menuItems);
                //setMenuList(menuList);
            },
            failure: (err) => {

            }
        })
    }

    function changeLevel(level) {
        if (level === "2") {
            setIcon("fa-circle-o")
        } else if (level === "1") {
            setIcon("")
        } else if (level === "0") {
            setIcon("")
        }
        setLevel(level);
    }

    useEffect(() => {
        if (menuItems.length === 0) {
            getMenu();
        }
        return () => {
        }
    }, [menuItems])

    //console.log(menuItems)

    function addMenu() {
        if (menuName !== "") {
            var mReqMenu
            var url

            switch (level) {
                case "0":
                    mReqMenu = new ReqMenu({
                        level, menuName, sequence
                    })
                    url = URL_MENU_ADDHEADER
                    break;
                case "1":
                    mReqMenu = new ReqMenu({
                        level, menuName, sequence, icon, upperId, link
                    })
                    url = URL_MENU_ADDTITLE
                    break;
                case "2":
                    mReqMenu = new ReqMenu({
                        level, menuName, sequence, icon, upperId, link
                    })
                    url = URL_MENU_ADDITEM
                    break;
                default:
                    break;
            }

            apiMenu.addMenu({
                mReqMenu,
                url,
                success: () => {
                    Swal.fire({
                        type: 'success',
                        title: '提醒',
                        text: '新增成功',
                    })
                    setMenuName("")
                    setSequence(0)
                    setIcon("")
                    setUpperId("")
                    setLink("")
                    setMenuItems([])
                    getMenu();
                },
                failure: (err) => {
                    Swal.fire({
                        type: 'error',
                        title: '提醒',
                        text: '新增失敗',
                    })
                }
            })
        } else {
            Swal.fire({
                type: 'error',
                title: '提醒',
                text: '新增失敗',
            })
        }
    }

    if (menuItems === "" || menuItems.length === undefined)
        return (<></>)
    else {
        const divStyle={
            overflowY: 'scroll',
            border:'1px solid green',
            //width:'500px',
            float: 'left',
            height:'500px',
            position:'relative'
          };
        var title = "選單新增"
        var content = <div className="row">
            <div className="col-sm-8" style={divStyle}>
                <div className="box box-primary">
                    <div className="box-header">
                        <ol>
                            {
                                menuItems.map((item, index) => (
                                    <MHeader key={"MH_" + index + item.menuId} item={item} />
                                ))
                            }
                        </ol>
                    </div>
                </div>
            </div>
            <div className="col-sm-4">
                <div className="box box-danger">
                    <div className="box-header with-border">
                        <div className="form-group">
                            <label>選單類別</label>
                            <select className="form-control" onChange={e => changeLevel(e.target.value)}>
                                <option value="0">標題</option>
                                <option value="1">主選單</option>
                                <option value="2">次選單</option>
                            </select>
                        </div>
                        <MenuContent level={level} menuName={menuName} sequence={sequence} icon={icon} upperId={upperId} link={link}
                            setMenuName={setMenuName} setSequence={setSequence} setIcon={setIcon} setUpperId={setUpperId} setLink={setLink} />
                    </div>
                    <div className="box-footer">
                        <button type="submit" className="btn btn-primary" onClick={addMenu}>Submit</button>
                    </div>
                </div>
            </div>
        </div>
        return (
            <ContentBox title={title} content={content} hasDrawer={true} />
        )
    }
}




function MenuContent({ level, menuName, sequence, icon, upperId, link,
    setMenuName, setSequence, setIcon, setUpperId, setLink }) {
    if (level === "0") {
        return <MenuHeader name={menuName} seq={sequence} setName={setMenuName} setSeq={setSequence} />
    } else if (level === "1") {
        return (
            <>
                <MenuHeader level={level} name={menuName} seq={sequence} setName={setMenuName} setSeq={setSequence} />
                <MenuTitle level={level} ic={icon} uid={upperId} setIc={setIcon} setUid={setUpperId} />
                <MenuItem level={level} li={link} setLi={setLink} />
            </>
        )
    } else if (level === "2") {
        return (
            <>
                <MenuHeader level={level} name={menuName} seq={sequence} setName={setMenuName} setSeq={setSequence} />
                <MenuTitle level={level} ic={icon} uid={upperId} setIc={setIcon} setUid={setUpperId} />
                <MenuItem level={level} li={link} setLi={setLink} />
            </>
        )
    } else {
        return <></>
    }
}


function MenuHeader({ level, name, seq, setName, setSeq }) {
    const [lv, setLevel] = useState(level);
    const [menuName, setMenuName] = useState(name);
    const [sequence, setSequence] = useState(seq);

    useEffect(() => {
        if (lv !== level) {
            setLevel(level)
            setMenuName(name)
            setSequence(seq)
        }
    })
    useEffect(() => {
        setName(menuName);
    }, [menuName])

    useEffect(() => {
        setSeq(sequence);
    }, [sequence])

    return (
        <>
            <div className="form-group">
                <label htmlFor="menuName">選單名稱</label>
                <input type="text" className="form-control" id="menuName" placeholder="" value={menuName} onChange={e => setMenuName(e.target.value)} />
            </div>
            <div className="form-group">
                <label htmlFor="sequence">排序</label>
                <input type="number" className="form-control" id="sequence" placeholder="" value={sequence} onChange={e => setSequence(e.target.value)} />
            </div>
        </>
    )
}



function MenuTitle({ level, ic, uid, setIc, setUid }) {
    const [lv, setLevel] = useState(level);
    const [icon, setIcon] = useState(ic);
    const [upperId, setUpperId] = useState(uid);

    useEffect(() => {
        if (lv !== level) {
            setLevel(level)
            setIcon(ic)
            setUpperId(uid)
        }
    })

    useEffect(() => {
        setIc(icon);
    }, [icon])

    useEffect(() => {
        setUid(upperId);
    }, [upperId])

    return (
        <>
            <div className="form-group">
                <label htmlFor="icon">圖示</label>
                <input type="text" className="form-control" id="icon" placeholder="" value={icon} onChange={e => setIcon(e.target.value)} />
            </div>
            <div className="form-group">
                <label htmlFor="upperId">上一層ID</label>
                <input type="text" className="form-control" id="upperId" placeholder="參考左邊列表" value={upperId} onChange={e => setUpperId(e.target.value)} />
            </div>
        </>
    )
}

function MenuItem({ level, li, setLi }) {
    const [lv, setLevel] = useState(level);
    const [link, setLink] = useState(li);

    useEffect(() => {
        if (lv !== level) {
            setLevel(level)
            setLink(li)
        }
    })

    useEffect(() => {
        setLi(link)
    }, [link])
    return (
        <>
            <div className="form-group">
                <label htmlFor="link">連結</label>
                <input type="text" className="form-control" id="link" placeholder="請輸入連結網址" value={link} onChange={e => setLink(e.target.value)} />
            </div>
        </>
    )
}